import { keyframes } from '@chakra-ui/react';
const skeletonWaveKeyframes = () => keyframes({
    from: { transform: 'translateX(-100%)' },
    to: { transform: 'translateX(100%)' },
});
const baseStyle = {
    animation: 'none',
    background: 'none',
    backgroundColor: 'neutral.100',
    borderRadius: 4,
    opacity: 1,
    overflow: 'hidden',
    position: 'relative',
    '&&:after': {
        animation: `${skeletonWaveKeyframes()} 1.6s ease-in-out 0.5s infinite`,
        bgGradient: 'linear(to-l, transparent, neutral.200, transparent)',
        bottom: 0,
        content: '""',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        width: '500px',
        visibility: 'visible',
    },
};
export default {
    baseStyle,
};
//# sourceMappingURL=skeleton.js.map